export const profile = {
  name: "Griffin Gore",
  title: "IT Systems Engineer · Software Developer",
  summary:
    "IT Systems Engineer and full-stack developer who works at the systems administration and infrastructure level while building production software end to end. I own enterprise infrastructure, network and firewall security, M365 and Active Directory administration, endpoint compliance, and cyber incident response across a distributed, multi-office organization — and I build the custom hardware and software solutions that close the gaps commercial tools leave.",
  email: "griffingore97@gmail.com",
  github: "https://github.com/liq543",
  linkedin: "https://www.linkedin.com/in/griffin-gore/",
  resumeFile: "/Griffin_Gore_Resume.pdf",
};

export const experience = [
  {
    role: "IT Systems Engineer II",
    company: "Mangan Inc.",
    period: "Nov 2024 — Present",
    points: [
      "Serve as the senior technical resource for a distributed, multi-office organization — owning core infrastructure, network security, endpoint management, and M365 administration, while independently designing and shipping the custom software and hardware that supports the business.",
      "Lead cyber incident response end to end: detection and triage, containment, investigation, and remediation of phishing, account compromise, and malware events, followed by root-cause hardening and user communication.",
      "Deploy and manage enterprise firewall infrastructure, primarily Palo Alto with Prisma, handling network security, segmentation, VPN, and threat prevention; experience extends to Cisco ASA and Fortinet.",
      "Administer the enterprise M365/Azure AD environment — Exchange Online, SharePoint, Teams, Intune, licensing, conditional access, and MFA enforcement — alongside on-premises Active Directory and Group Policy.",
      "Manage and maintain VMware/ESXi, Hyper-V, Windows Server infrastructure, and enterprise storage, and deploy systems with Endpoint Central (patching, software deployment, compliance enforcement) across a distributed workforce.",
      "Led the enterprise Windows 11 migration: created the standardized image and planned and deployed the rollout to 500+ workstations.",
      "Spearheaded the migration to Azure File Services, modernizing storage and access, improving security posture, and aligning with SOC-2 requirements.",
      "Designed and implemented new IT infrastructure for multiple office relocations, moving and onboarding 100+ employees with minimal downtime.",
      "Independently designed, built, and deployed a proprietary hardware-based timeclock system for 75+ warehouse and hourly employees — Android smart scanner devices, a custom-built kiosk, and the software behind both — automating time tracking and streamlining payroll.",
      "Built an internal application portal for managing, distributing, and securing proprietary company applications, many of which I developed in-house.",
      "Lead architect and project owner for an enterprise-wide PII compliance initiative, developing custom software to identify and secure sensitive data across the organization.",
      "Built custom budget software with advanced reporting, enabling streamlined financial tracking and data-driven decisions for stakeholders.",
      "Champion organizational AI adoption — training team members on AI tools and developing AI-powered automations across departments.",
    ],
  },
  {
    role: "IT Technical Specialist / Full Stack Developer",
    company: "Tech-Mar (MSP)",
    period: "Nov 2023 — Nov 2024",
    points: [
      "Administered O365/M365, Azure AD, Active Directory, Intune, and Google Workspace environments for a diverse client base.",
      "Developed automation solutions in Python and PowerShell, streamlining workflows and tailoring custom software to client specifications.",
      "Built and maintained websites and digital platforms for clients, with an eye on security, usability, and long-term support.",
      "Owned the full project lifecycle — from lead acquisition and sales conversations through planning, execution, delivery, and support.",
      "Configured and maintained VMware, Hyper-V, and Azure storage for client environments.",
      "Delivered infrastructure projects: workstation deployments, Intune rollouts, SharePoint/PowerApps solutions, and Power BI dashboards.",
      "Provided end-to-end network support: DNS, DHCP, VPN, VLANs, VoIP, firewalls, and switches.",
    ],
  },
  {
    role: "IT Help Desk & Systems Technician",
    company: "Global Geophysical",
    period: "Feb 2018 — Jan 2023",
    points: [
      "Maintained the company's network infrastructure and provided comprehensive desktop support.",
      "Prioritized and resolved help desk calls, ensuring timely resolution and minimal user disruption.",
      "Oversaw desktop setup and managed inventory control through equipment lifecycle transitions.",
      "Maintained NAS drives for efficient remote access and data availability.",
    ],
  },
];

export const skills = [
  { group: "Infrastructure & Cloud", items: "Azure, VMware/ESXi, Hyper-V, Windows Server, Endpoint Central, enterprise storage" },
  { group: "Systems Administration", items: "Active Directory, Group Policy, O365/M365, Exchange Online, Intune, endpoint lifecycle" },
  { group: "Security & Compliance", items: "Cyber incident response, SOC-2, MFA & conditional access, encryption standards, PII/data protection" },
  { group: "Network Security", items: "Palo Alto & Prisma, Cisco ASA, Fortinet, firewall architecture & segmentation" },
  { group: "Networking", items: "DNS, DHCP, VPN, VLANs, VoIP, switches" },
  { group: "Development", items: "Python, PowerShell, Rust, JavaScript, React, Node.js, hardware/device integration" },
  { group: "Platforms & Reporting", items: "Azure AD/Entra ID, SharePoint, Power BI, Google Workspace" },
  { group: "AI & Automation", items: "AI implementation & training, process automation, workflow optimization" },
];

export const education = [
  {
    credential: "Full Stack Developer — Coding Bootcamp",
    school: "The University of Texas at Austin",
    period: "Jun 2023 — Sep 2023",
  },
  {
    credential: "B.B.A., Finance (100+ credit hours completed)",
    school: "University of Houston",
    period: "2020 — 2023",
  },
  {
    credential: "A.A., Business Administration — 3.6 GPA",
    school: "Houston Community College",
    period: "2019 — 2020",
  },
];
